var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShovel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5489 3.57036C16.8682 2.6768 13.9149 3.26369 11.7796 5.11432L9.77814 6.84892C9.33959 7.229 9.3156 7.90135 9.72597 8.31171L11.7071 10.2929L13.7071 12.2929L15.6883 14.274C16.0987 14.6844 16.771 14.6604 17.1511 14.2219L18.8857 12.2204C20.7363 10.0851 21.3232 7.13183 20.4297 4.45114L20.2095 3.79056L19.5489 3.57036ZM10.4697 3.60294C13.1389 1.28965 16.8305 0.556043 20.1813 1.673L21.3163 2.0513L21.7906 2.20942L21.9487 2.68376L22.327 3.81869C23.444 7.16954 22.7104 10.8611 20.3971 13.5303L18.6625 15.5317C17.5222 16.8474 15.5052 16.9194 14.2741 15.6883L13 14.4142L4.70714 22.7071C3.76433 23.6499 2.23573 23.6499 1.29292 22.7071C0.350113 21.7643 0.350113 20.2357 1.29292 19.2929L9.58582 11L8.31175 9.72593C7.08066 8.49483 7.15261 6.47779 8.46828 5.33754L10.4697 3.60294ZM11 12.4142L2.70714 20.7071C2.54538 20.8689 2.54538 21.1311 2.70714 21.2929C2.8689 21.4546 3.13116 21.4546 3.29292 21.2929L11.5858 13L11 12.4142ZM12.2929 7.29288C12.6834 6.90236 13.3166 6.90236 13.7071 7.29288L16.7071 10.2929C17.0977 10.6834 17.0977 11.3166 16.7071 11.7071C16.3166 12.0976 15.6834 12.0976 15.2929 11.7071L12.2929 8.70709C11.9024 8.31657 11.9024 7.6834 12.2929 7.29288Z",
    fill: "#780000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShovel);
export default __webpack_public_path__ + "static/media/shovel.eb1fc16408baa9ce79a3b1c44d5042df.svg";
export { ForwardRef as ReactComponent };